// extracted by mini-css-extract-plugin
export default {"container":"style_container__gKrT7","logo":"style_logo__8sfL5"};